function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_578",
  "data-name": "Group 578",
  transform: "translate(-353.704 -3148.35)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_151",
  "data-name": "Path 151",
  d: "M386.487,3148.723a10.874,10.874,0,0,1,7.342.611h0a10.909,10.909,0,0,0,9.042,0h0a10.9,10.9,0,0,1,13.395,3.589h0a10.9,10.9,0,0,0,7.831,4.521h0a10.9,10.9,0,0,1,9.805,9.8h0a10.9,10.9,0,0,0,4.521,7.831h0a10.9,10.9,0,0,1,3.589,13.4h0a10.9,10.9,0,0,0,0,9.042h0a10.9,10.9,0,0,1-3.589,13.4h0a10.9,10.9,0,0,0-4.521,7.83h0a10.9,10.9,0,0,1-9.805,9.806h0a10.9,10.9,0,0,0-7.831,4.521h0a10.9,10.9,0,0,1-13.395,3.589h0a10.9,10.9,0,0,0-9.042,0h0a10.9,10.9,0,0,1-13.4-3.589h0a10.9,10.9,0,0,0-7.83-4.521h0a10.9,10.9,0,0,1-9.806-9.806h0a10.9,10.9,0,0,0-4.521-7.83h0a10.9,10.9,0,0,1-3.589-13.4h0a10.9,10.9,0,0,0,0-9.042h0a10.9,10.9,0,0,1,3.589-13.4h0a10.9,10.9,0,0,0,4.521-7.831h0a10.9,10.9,0,0,1,9.806-9.8h0a10.9,10.9,0,0,0,7.83-4.521h0A10.881,10.881,0,0,1,386.487,3148.723Z",
  fill: "#999"
}), /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_46",
  "data-name": "Ellipse 46",
  cx: 37.182,
  cy: 37.182,
  r: 37.182,
  transform: "translate(361.168 3155.813)",
  fill: "none",
  stroke: "#e6e6e6",
  strokeMiterlimit: 10,
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("g", {
  id: "Group_100",
  "data-name": "Group 100"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_155",
  "data-name": "Path 155",
  d: "M416.857,3201.977h-3.24v-1.516a1.459,1.459,0,0,0-1.471-1.253v-13.9a2.287,2.287,0,0,0-4.575,0v13.9a1.459,1.459,0,0,0-1.471,1.253v1.516h-3.24a1.349,1.349,0,0,0-1.349,1.348v8.909a1.35,1.35,0,0,0,1.349,1.349h14a1.348,1.348,0,0,0,1.348-1.349v-8.909A1.349,1.349,0,0,0,416.857,3201.977Zm-4.618,0h-4.763v-1.139a.653.653,0,0,1,.359-.561,2.287,2.287,0,0,0,4.045,0,.652.652,0,0,1,.36.561v1.139Zm-31.188-29.051a5.049,5.049,0,1,1,5.049,5.049A5.049,5.049,0,0,1,381.051,3172.926Zm23.758,0a5.049,5.049,0,1,1,5.049,5.049A5.049,5.049,0,0,1,404.809,3172.926ZM399.47,3189.6a2.171,2.171,0,0,1-2.17,2.171h-8.068a2.17,2.17,0,0,1-1.775-.921l-4.032-5.729a2.171,2.171,0,0,1,3.55-2.5l3.383,4.808H397.3A2.171,2.171,0,0,1,399.47,3189.6Zm-5.7,25.065a2.717,2.717,0,0,1-5.344.981l-2.272-13.721-2.273,13.721a2.717,2.717,0,0,1-5.344-.981l2.334-14.094,0-16.4a5.175,5.175,0,0,1,10.35,0v2.748h-.323l-3.26-4.73a2.921,2.921,0,0,0-4.182-.561,2.725,2.725,0,0,0-.581,3.984l3.959,5.773a2.7,2.7,0,0,0,2.4,1.217h2.247l0,8.21Zm10.7-22.894h-5.149a2.861,2.861,0,0,0,0-4.341h5.147v-3.257a5.165,5.165,0,1,1,10.33,0l0,17.279h-.662v-1a1.779,1.779,0,0,0-1.081-1.633v-13.6a3.2,3.2,0,0,0-6.4,0v13.6a1.778,1.778,0,0,0-1.081,1.633v1h-1.1Zm-1.617,22.329h4.816l-.256,1.546a2.716,2.716,0,0,1-5.343-.981l.114-.691A1.857,1.857,0,0,0,402.859,3214.1Zm14.45.565a2.717,2.717,0,0,1-5.344.981l-.256-1.546h5.148a1.853,1.853,0,0,0,.352-.034Z",
  fill: "#e6e6e6"
})));

var SvgTeamwork = function SvgTeamwork(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 89.291,
    height: 89.291,
    viewBox: "0 0 89.291 89.291",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTeamwork, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/teamwork.fcf5a3d8.svg";
export { ForwardRef as ReactComponent };